const fallbackBaseUrl =
  typeof window !== "undefined" && window.__APP_CONFIG__?.API_BASE_URL
    ? window.__APP_CONFIG__.API_BASE_URL
    : "";

export const baseURL = process.env.REACT_APP_API_BASE_URL || fallbackBaseUrl;
const normalizedBaseUrl = typeof baseURL === "string" ? baseURL.trim() : "";

if (!normalizedBaseUrl) {
  const message =
    "API base URL is empty. Set REACT_APP_API_BASE_URL or window.__APP_CONFIG__.API_BASE_URL.";
  if (process.env.NODE_ENV === "production") {
    throw new Error(message);
  } else {
    console.warn(`[CONFIG] ${message}`);
  }
}
export const apiKey = process.env.REACT_APP_API_SECRET_KEY || "";
export const projectName = "rbah";
